"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestroEquipoEnAcciN() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: galleryRef,
    isVisible: galleryVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const galleryItems = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/security_monitoring_center.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/security_monitoring_center.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/security_monitoring_center.png-wvc-sizes",
    alt: "Centro de monitoreo avanzado con múltiples pantallas",
    caption: "Centro de Control C5",
    model: "UNIT-OPS-24/7",
    gridClass: "md:col-span-8 md:row-span-2 aspect-[4/3] md:aspect-auto"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/security_officer_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/security_officer_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/security_officer_detail.png-wvc-sizes",
    alt: "Detalle de uniforme y equipo de comunicación profesional",
    caption: "Equipamiento Táctico",
    model: "STD-PRO-SEC",
    gridClass: "md:col-span-4 md:row-span-2 aspect-[3/4] md:aspect-auto"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/corporate_security_lobby.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/corporate_security_lobby.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/corporate_security_lobby.png-wvc-sizes",
    alt: "Vestíbulo corporativo con personal de seguridad",
    caption: "Protección Corporativa",
    model: "CORP-SAFE-01",
    gridClass: "md:col-span-4 aspect-[4/3]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/surveillance_camera_tech.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/surveillance_camera_tech.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/surveillance_camera_tech.png-wvc-sizes",
    alt: "Cámara de vigilancia de alta tecnología",
    caption: "Vigilancia Digital",
    model: "TECH-VIS-4K",
    gridClass: "md:col-span-4 aspect-[4/3]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/security_patrol_vehicle.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/security_patrol_vehicle.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/security_patrol_vehicle.png-wvc-sizes",
    alt: "Unidad de patrullaje rotulada de Grupo Poseidón",
    caption: "Unidades de Reacción",
    model: "MOB-RESP-GPS",
    gridClass: "md:col-span-4 aspect-[4/3]"
  }];
  const stats = [{
    value: "24/7",
    label: "Vigilancia Activa"
  }, {
    value: "100%",
    label: "Personal Certificado"
  }, {
    value: "5min",
    label: "Respuesta Promedio"
  }];
  return <section data-section-id="5101" id="nuestro-equipo-en-acción" className="relative overflow-hidden bg-background text-foreground py-20 md:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-40 -right-40 w-[600px] h-[600px] opacity-[0.04]">
        <div className="absolute inset-0 rounded-md border border-primary" style={{
        borderRadius: "0%"
      }} />
        <div className="absolute inset-8 rounded-md border border-primary" style={{
        borderRadius: "0%"
      }} />
        <div className="absolute inset-20 rounded-md border border-primary" style={{
        borderRadius: "0%"
      }} />
        <div className="absolute inset-36 rounded-md border border-primary" style={{
        borderRadius: "0%"
      }} />
      </div>

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 mb-16 md:mb-20 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.15em] text-primary mb-6">
              — § 04 / Infraestructura
            </p>
            <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tighter text-foreground">
              Donde la disciplina
              <br />
              <span className="text-primary">se vuelve tecnología.</span>
            </h2>
          </div>
          <div className="flex flex-col justify-end">
            <p className="text-base md:text-[18px] leading-relaxed text-muted-foreground mb-8 max-w-xl font-default">
              Cada elemento del entorno operativo de POSEIDON está diseñado para la vigilancia absoluta. Nuestra infraestructura combina precisión táctica con tecnología de vanguardia para garantizar una protección sin fisuras en cada sector.
            </p>
            <div>
              <Button asChild variant="link" className="group h-auto p-0 text-foreground hover:text-primary text-base font-semibold">
                <Link to="/TechnologyPage" className="inline-flex items-center gap-2">
                  <span className="border-b-2 border-primary/40 group-hover:border-primary pb-0.5 transition-colors">
                    Explora nuestra tecnología
                  </span>
                  <ArrowUpRight className="size-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div ref={galleryRef} className={`grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 mb-16 md:mb-20 transition-all duration-1000 ease-out ${galleryVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {galleryItems.map((item, i) => <div data-index={i} key={i} className={`group relative overflow-hidden rounded-md border border-border bg-card shadow-md ${item.gridClass}`}>
              <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="h-full w-full object-cover grayscale hover:grayscale-0 transition-all duration-[2000ms] ease-out group-hover:scale-[1.05]" />
              {}
              <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-80" />
              {}
              <div className="absolute bottom-0 left-0 p-4 md:p-5">
                <div className="font-default font-semibold text-foreground text-lg md:text-xl leading-tight mb-1">
                  {item.caption}
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-primary">
                  {item.model}
                </div>
                <div className="mt-2 h-1 w-0 bg-primary transition-all duration-500 ease-out group-hover:w-12" />
              </div>
              {}
              <div className="absolute top-2 left-2 text-primary opacity-40 font-mono text-[8px]">+</div>
              <div className="absolute top-2 right-2 text-primary opacity-40 font-mono text-[8px]">+</div>
              <div className="absolute bottom-2 right-2 text-primary opacity-40 font-mono text-[8px]">+</div>
            </div>)}
        </div>

        {}
        <div ref={statsRef} className={`grid grid-cols-1 md:grid-cols-3 border-t border-b border-border transition-all duration-1000 ease-out ${statsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {stats.map((stat, i) => <div data-index={i} key={i} className={`flex flex-col md:flex-row md:items-baseline gap-3 md:gap-5 py-8 md:py-10 px-2 md:px-8 ${i > 0 ? "md:border-l border-border" : ""} ${i < stats.length - 1 ? "border-b md:border-b-0 border-border" : ""}`}>
              <span className="font-default font-bold text-4xl md:text-5xl text-primary leading-none">
                {stat.value}
              </span>
              <span className="font-mono text-xs uppercase tracking-[0.15em] text-muted-foreground">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}